module.exports = __webpack_public_path__ + "img/standard-chartered-img.bc74f08f.png";